import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/listing/actionTypes';

import { remove } from './utils';

export default function* listenRemove() {
  yield takeEvery(actionTypes.REMOVE, remove);
}
